import {Component, ChangeDetectionStrategy, Output, EventEmitter, Input, OnInit} from '@angular/core';
import {TranslateService} from "../../../../translate/services/translate.service";
import {IconEnum} from "../interfaces/icon.enum";
/* tslint:disable */

@Component({
	selector: 'cp-icon-button',
	templateUrl: './icon.button.html',
	styleUrls: ['./icon.button.scss'],
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class IconButtonComponent implements OnInit{

	@Input() icon: IconEnum;

	@Output() iconClick: EventEmitter<Object> = new EventEmitter<Object>();

	constructor(private translateService:TranslateService){
	}

	public iconClass: string;
	public tooltip:string;

	public ngOnInit() {
		switch (this.icon) {
			case IconEnum.AddProcedure:
				this.iconClass = "cp-icon-procedure_add";
				this.tooltip = "Select";
				break;
			case IconEnum.DeleteProcedure:
				this.iconClass = "cp-icon-procedure_delete";
				this.tooltip = "Remove";
				break;
			case IconEnum.AddFavorite:
				this.iconClass = "cp-icon-favorite_add";
				this.tooltip = "Add to favorites";
				break;
			case IconEnum.RemoveFavorite:
				this.iconClass = "cp-icon-favorite_remove";
				this.tooltip = "Remove from favorites";
				break;
		}
		this.tooltip = <string> this.translateService.instant(this.tooltip);
	}

	public onClick(e) {
		this.iconClick.emit(e);
	}
}
